module.exports = __webpack_public_path__ + "img/group23-vi.01cc3f75.png";